<template>
  <span>
    <v-btn @click="dialog = !dialog" color="primary" dark>Upload Hoá Đơn Điện Nước</v-btn>
    <v-dialog max-width="80%" v-model="dialog">
      <app-card>
        <h4>UPLOAD HÓA ĐƠN ĐIỆN NƯỚC</h4>
        <p class="fs-14 grey--text">
          Tải lên hóa đơn điện nước dạng PDF. Với hóa đơn nước, tải thẳng file ZIP nhận từ bên cấp nước (không cần
          giải nén hay in ra PDF).
        </p>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select :items="['Điện', 'Nước']" v-model="form.type" :rules="[rules.required]" prepend-icon="bolt"
                  label="Loại"></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select label="Tòa nhà" v-model="form.building" :items="list_building" prepend-icon="domain"
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <div>Chọn file hóa đơn để tải lên (PDF, hoặc ZIP/XML với hóa đơn nước)</div>
                <input type="file" ref="fileInput" @change="handleFileChange" :accept="acceptedFileTypes" required />
              </v-flex>
              <v-flex xs12 md6 v-if="isPdfSelected">
                <v-text-field label="Mật khẩu PDF (nếu có)" v-model="form.pdfPassword"
                  prepend-icon="lock"></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="alert.show">
                <v-alert :value="alert.show" :type="alert.type" outline>
                  {{ alert.text }}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loading.submit" :disabled="loading.submit || alert.show" @click="submit" color="primary"
              class="white--text">
              Tải lên
            </v-btn>
            <v-btn @click="dialog = false; clearInput()">Hủy</v-btn>
          </v-card-actions>
        </v-form>

        <TablePreviewUploadPdfDienNuoc v-if="extractedData.length > 0" :extractedData="extractedData" :billType="form.type"
          :billDate="extractedData.length > 0 ? extractedData[0].bill_date : ''" @confirm="confirmExtractedData"
          @reject="rejectExtractedData"></TablePreviewUploadPdfDienNuoc>

      </app-card>
    </v-dialog>
  </span>
</template>

<script>
import AppConfig from "Constants/AppConfig";
import { list_building } from "Constants/db-config";
import TablePreviewUploadPdfDienNuoc from './TablePreviewUploadPdfDienNuoc.vue';
import api from 'Api';

// Phải khớp với giới hạn dung lượng của API upload hóa đơn điện nước
const MAX_UPLOAD_SIZE_MB = 10;
// Hóa đơn nước do bên cấp nước phát dạng ZIP (bên trong có file XML); hóa đơn điện chỉ có PDF
const ALLOWED_EXTENSIONS = ['pdf', 'zip', 'xml'];

export default {
  name: "dialog-upload-dien-nuoc",
  components: {
    TablePreviewUploadPdfDienNuoc
  },
  data() {
    return {
      dialog: false,
      loading: {
        submit: false,
      },
      form: {
        type: null,
        building: null,
        pdfFile: null,
        pdfPassword: null,
      },
      list_building,
      rules: {
        required: (value) => !!value || "Vui lòng chọn/nhập thông tin này.",
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      extractedData: [],
    };
  },
  computed: {
    acceptedFileTypes() {
      return ALLOWED_EXTENSIONS.map((extension) => `.${extension}`).join(',');
    },
    // Dựa vào đuôi file vì trình duyệt (nhất là trên Windows) gán kiểu file ZIP không thống nhất
    fileExtension() {
      const fileName = this.form.pdfFile ? this.form.pdfFile.name : '';
      const dotIndex = fileName.lastIndexOf('.');
      return dotIndex === -1 ? '' : fileName.slice(dotIndex + 1).toLowerCase();
    },
    isPdfSelected() {
      return !this.form.pdfFile || this.fileExtension === 'pdf';
    },
  },
  watch: {
    export_csv(){
      this.exportCSV();
    }
  },
  methods: {
    handleFileChange(event) {
      this.form.pdfFile = event.target.files[0] || null;
    },
    // Trả về câu báo lỗi nếu file đã chọn không hợp lệ, null nếu hợp lệ
    getFileError() {
      const file = this.form.pdfFile;
      if (!file) {
        return "Vui lòng chọn file hóa đơn để tải lên.";
      }
      if (!ALLOWED_EXTENSIONS.includes(this.fileExtension)) {
        return "Chỉ nhận file PDF, hoặc file ZIP/XML đối với hóa đơn nước.";
      }
      if (this.form.type !== 'Nước' && this.fileExtension !== 'pdf') {
        return `Hóa đơn ${this.form.type} chỉ nhận file PDF. File ZIP/XML chỉ dùng cho hóa đơn nước.`;
      }
      if (file.size > MAX_UPLOAD_SIZE_MB * 1024 * 1024) {
        return `File vượt quá ${MAX_UPLOAD_SIZE_MB} MB.`;
      }
      return null;
    },
    clearInput: function () {
      this.$refs.form.reset();
      this.form.type = null;
      this.form.building = null;
      this.form.pdfFile = null;
      this.form.pdfPassword = null;
      this.alert.show = false;
      this.extractedData = [];
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    submit: async function () {
      if (!this.$refs.form.validate()) {
        swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin và chọn file hóa đơn hợp lệ.", "error");
        return;
      }

      const fileError = this.getFileError();
      if (fileError) {
        swal.fire("Lỗi", fileError, "error");
        return;
      }

      const formData = new FormData();
      formData.append('type', this.form.type);
      formData.append('building', this.form.building);
      formData.append('file', this.form.pdfFile);
      if (this.form.pdfPassword && this.fileExtension === 'pdf') {
        formData.append('pdfPassword', this.form.pdfPassword);
      }

      this.loading.submit = true;
      try {
        const response = await fetch(
          `${AppConfig.host}/api/state-electricity-water/upload-pdf`,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: "Bearer " + this.$store.state.auth.token,
            },
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          this.extractedData = responseData;

          swal.fire({
            title: "Upload hóa đơn thành công",
            text: "Đã trích xuất dữ liệu hóa đơn. Vui lòng kiểm tra và xác nhận.",
            icon: "success",
            showConfirmButton: true,
          });

        } else {
          const error = await response.json();
          swal.fire("Lỗi", error.message || "Đã có lỗi xảy ra khi tải lên.", "error");
          this.clearInput();
        }
      } catch (error) {
        console.error("Lỗi khi upload file:", error);
        swal.fire("Lỗi kết nối", "Không thể kết nối đến máy chủ. Vui lòng thử lại sau.", "error");
        this.clearInput();
      } finally {
        this.loading.submit = false;
      }
    },
    async confirmExtractedData() {
      const data = await api.saveOrUpdateStateElectricityWaterBills(this.extractedData);

      this.loading.submit = false;

      if (data.status === 200) {
        this.dialog = false;
        this.clearInput();
        this.$emit("reloadTable");
        swal.fire("Thành công", "Dữ liệu đã được xác nhận và sẽ được lưu.", "success");
      } else { swal.fire("Lỗi", data.message, "error") };
    },
    rejectExtractedData() {
      swal.fire("Thông báo", "Vui lòng kiểm tra lại file hóa đơn hoặc tải lên file khác.", "info");
      this.clearInput();
    },
  },
};
</script>

<style></style>